import styled from '@emotion/styled'

export const StyledReadOnlyView = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: row;
`
